import { emailSchema, phoneRequiredSchema, statusSchema, stringRequiredSchema, urlRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const addParentSchema = object().shape({
    firstname: stringRequiredSchema,
    lastname: stringRequiredSchema,
    phone: phoneRequiredSchema,
    email: emailSchema,
    city: stringRequiredSchema,
    // status: statusSchema,
    isLoginAllowed: stringRequiredSchema,
});

export default addParentSchema;